import { useContext } from 'react';
import DiscountContext from '~/context/common/DiscountContext';
import TradeContext, {
  useGetTradeInStatus
} from '~/context/common/TradeContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useIsHighNetTrade(): boolean {
  const { price = 0 } = useGetVehicleDetails();
  const { totalDiscount } = useContext(DiscountContext);

  const { selectedTrade, isTradeInApplied } = useContext(TradeContext);
  const isActiveTrade = useGetTradeInStatus().isActive;

  const { offerAmount = 0 } = selectedTrade ?? {};
  const priceWithDiscountsApplied = price - totalDiscount;

  return isTradeInApplied && isActiveTrade
    ? offerAmount > priceWithDiscountsApplied
    : false;
}
